// extracted by mini-css-extract-plugin
module.exports =  {"root":"jFXhtJ1vDLLIjXiSszzE","container":"ekI8K3tz4UKxRVgd7xkM","label":"Uvk81lC3koz7PIGwGs5c","header":"qjsrFyiNFQv9cIJ0Q2LC"};